export const getMParticle = () => {
  if (typeof window === 'undefined') {
    return;
  }
  return window.mParticle;
};
